<div class="flex flex-1 flex-col">
  <rk-trash-header
    (changeSearch)="onChangeSearch($event)"
    [displayedArchivedTracksLength]="
      (searchedArchivedTracks$ | async) && (searchedArchivedTracks$ | async).length
    "
  ></rk-trash-header>

  <ng-container *ngIf="!(isLoading$ | async); else loading_medialist">
    <rk-trash-audio-table
      class="flex flex-1 flex-col"
      *ngIf="(searchedArchivedTracks$ | async) !== null; else loading_medialist"
      [archivedTracks]="searchedArchivedTracks$ | async"
      [columns]="columns$ | async"
      [trashLength]="(archivedTracks$ | async)?.length"
      [searchField$]="searchSubject.asObservable()"
    ></rk-trash-audio-table>
  </ng-container>
</div>

<ng-template #loading_medialist>
  <div class="mt-32">
    <rk-loader [isLoading]="true" [size]="60" [center]="true"></rk-loader>
  </div>
</ng-template>
